<template>
    <section class="farmerContainer">
            <div class="container-fluid farms">
                <div class="row margin_top_lg">
                    <div class="col-lg-3 offset-lg-1">
                        <side-bar />
                    </div>
                    <div class="col-lg-7">
                        <div class="form-container">
                            <div class="">
                                <div class="section_header font-md">
                                    <h3 class="color__black font-bold">Change Password</h3>
                                </div>
                                <div class="content_inner">
                                    <form action="#" @submit.prevent="submit">
                                        <div class="row form_row_group">
                                            <div class="form_group_item col-md-5">
                                                <h4 class="form_row_title font-bold caps_upper font-sm">Current Password</h4>
                                            </div>
                                            <div class="form_group_item col-md-7">
                                                <label for="" class="control-label sr-only caps_upper font-bold font-sm">Current Password</label>
                                                <input type="password" v-model="formData.oldPassword" class="form-control" placeholder="Enter your current password">
                                            </div>
                                        </div>
                                        <div class="row form_row_group">
                                            <div class="form_group_item col-md-5">
                                                <h4 class="form_row_title font-bold caps_upper font-bold font-sm">New Password</h4>
                                            </div>
                                            <div class="form_group_item col-md-7">
                                                <label for="" class="control-label sr-only caps_upper font-bold font-sm">New Password</label>
                                                <input type="password" v-model="formData.newPassword" class="form-control" placeholder="Enter your new password">
                                            </div>
                                        </div>
                                        <div class="row form_row_group">
                                            <div class="form_group_item col-md-5">
                                                <h4 class="form_row_title font-bold caps_upper font-bold font-sm">Confirm New Password</h4>
                                            </div>
                                            <div class="form_group_item col-md-7">
                                                <label for="" class="control-label sr-only caps_upper font-bold font-sm">Confirm New Password</label>
                                                <input type="password" v-model="formData.confirmPassword" class="form-control" placeholder="Enter your new password again">
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end">
                                            <submit-button class="btn btn-primary" :loading="changingPassword" :disabled="checkField">Save changes</submit-button>
                                        </div>
                
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                </div>

                <div class="d-flex justify-content-end margin_top_lg">
                    <button class="btn btn-support btn-sm py-2 font-sm">
                        <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2" style="height: 16px; margin-bottom: -2px;"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11 5C8.23858 5 6 7.23858 6 10V11V18H3C1.89543 18 1 17.1046 1 16V12C1 10.8954 1.89543 10 3 10L4 10C4 6.13401 7.13401 3 11 3H13C16.866 3 20 6.13401 20 10H21C22.1046 10 23 10.8954 23 12V16C23 17.1046 22.1046 18 21 18H19.874C19.4299 19.7252 17.8638 21 16 21H14.7324C14.3866 21.5978 13.7403 22 13 22C11.8954 22 11 21.1046 11 20C11 18.8954 11.8954 18 13 18C13.7403 18 14.3866 18.4022 14.7324 19H16C17.1046 19 18 18.1046 18 17V11V10C18 7.23858 15.7614 5 13 5H11ZM4 12H3L3 16H4V12ZM11 12.25C11 12.9404 10.4404 13.5 9.75 13.5C9.05964 13.5 8.5 12.9404 8.5 12.25C8.5 11.5596 9.05964 11 9.75 11C10.4404 11 11 11.5596 11 12.25ZM14.25 13.5C14.9404 13.5 15.5 12.9404 15.5 12.25C15.5 11.5596 14.9404 11 14.25 11C13.5596 11 13 11.5596 13 12.25C13 12.9404 13.5596 13.5 14.25 13.5ZM20 12H21V16H20V12Z"
                                fill="#F2950A" />
                        </svg>
                        Support
                    </button>
                </div>
            </div>
            
        </section>
</template>

<script>
import SideBar from '@/components/off-taker/SideBar';
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            formData: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            error: false,
            changingPassword: false
        }
    },
    computed: {
        ...mapState(['user']),
        checkField() {
            if(this.formData.oldPassword === '' || this.formData.newPassword === '' || this.formData.confirmPassword === '') {
                return true;
            }
            if(this.formData.newPassword !== this.formData.confirmPassword) {
                return true
            }
            return false;
        }
    },
    methods: {
        // ...mapActions(['loginUser']),
        submit() {
            this.changingPassword = true;
            const formData = {
                oldPassword: this.formData.oldPassword,
                password: this.formData.newPassword,
                // email: this.user.email
            }
            this.$http.post('auth/passwords/change', formData)
            .then((response) => {
                this.$log(response)
                this.$toastr.success('Password changed successfully !!')
                this.clearForm()
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.changingPassword = false;
            })
        },
        checkConfirmPassword() {
            if(this.formData.newPassword !== this.formData.confirmPassword) {
                this.error = true
            } else {
                this.error = false
            }
        },
        clearForm() {
            this.formData = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            }
        }
    },
    components: {
        SideBar
    }
}
</script>

<style>

</style>